"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeitungsSerie = void 0;
const echain_product_models_1 = require("@igus/echain-product-models");
const Serie_1 = require("../Serie");
const echain_shared_articles_1 = require("@igus/echain-shared-articles");
class LeitungsSerie extends Serie_1.Serie {
    get seriesType() {
        return echain_product_models_1.ArticleType.leitung;
    }
    get articleSpecs() {
        return this.model.ArticleSpecs;
    }
    set articleSpecs(value) {
        this.model.ArticleSpecs = value;
    }
    get categories() {
        return this.model.Categories;
    }
    set categories(value) {
        this.model.Categories = value;
    }
    get hatMeterwareOhneStecker() {
        return this.model.HatMeterwareOhneStecker;
    }
    set hatMeterwareOhneStecker(value) {
        this.model.HatMeterwareOhneStecker = value;
    }
    get mainCategory() {
        return this.model.MainCategory;
    }
    set mainCategory(value) {
        this.model.MainCategory = value;
    }
    static fromScratch() {
        return new LeitungsSerie({});
    }
    static fromJson(json) {
        const serie = LeitungsSerie.fromScratch();
        serie.fromJson(json);
        return serie;
    }
    hasSpec(spec) {
        var _a;
        return !!((_a = this.articleSpecs) === null || _a === void 0 ? void 0 : _a.includes(spec));
    }
    /** Retrieves true if the LeitungSerie can be identified as readycable. */
    isReadycable() {
        return this.hasSpec(echain_shared_articles_1.ArticleSpecs.Readycable);
    }
    /** Retrieves true if the LeitungSerie can be identified as chainflex. */
    isChainflex() {
        return this.hasSpec(echain_shared_articles_1.ArticleSpecs.Chainflex);
    }
    /** Retrieves true if the LeitungSerie can be identified as PullWire. */
    isPullWire() {
        return this.hasSpec(echain_shared_articles_1.ArticleSpecs.PullWire);
    }
}
exports.LeitungsSerie = LeitungsSerie;
//# sourceMappingURL=LeitungsSerie.js.map